import React from 'react'
import Helmet from 'react-helmet';

import Base from './base';
import { Parent } from '../layouts/parent';

import { ContentHead } from '../components/content-head';
import { ContentColumns } from '../components/content-columns';
import { EmbeddedVideo } from '../components/embedded-video';
import { Gallery } from '../components/content-gallery';

export default class ContentPage extends Base {
  get backgroundColor () {
    return this.content.page?.festival?.color || '#5F58FA';
  }

  get breadcrumb () {
    return this.content.page.festival.title;
  }

  get injected () {
    return this.content.injected || {};
  }


  render () {
    return (
      <Parent { ...this.content }>
        <Helmet>
          <title>{ `${this.content.page.longTitle} - Europalia Arts Festival` }</title>
          <meta name="description" content={this.content.page.excerpt} />
          { this.image && <meta property="og:image" content={'https:' + this.image } /> }
        </Helmet>

        <ContentHead
          title={[this.content.page.year, this.content.page.longTitle].join(' ')}
          images={[ { image: this.content.page.image } ]}
          backgroundColor={this.backgroundColor}
        />

        <ContentColumns contentLeft={this.content.page.contentLeft} contentRight={this.content.page.contentRight} />

        { this.content.page.downloadButton && <a href={this.content.page.fileToDownload?.file?.url || ''} target="_blank" className="button button--download">{this.content.page.downloadButton}</a> }

        { this.content.page.linkedVideo && <EmbeddedVideo uri={this.content.page.linkedVideo} /> }
        { this.content.page.gallery && <Gallery images={this.content.page.gallery} /> }
      </Parent>
    );
  }
}